"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../../styles");

var styles = {
  navbar: {
    display: 'flex',
    alignItems: 'center',
    height: '60px',
    width: '100%',
    color: 'white',
    boxShadow: 'rgba(0, 0, 0, 0.5) 0px 1px 4px 0px'
  },
  primary: {
    extend: 'navbar',
    background: 'black',
    position: 'relative',
    zIndex: 5
  },
  secondary: {
    extend: 'navbar',
    background: _styles.colors.charcoal
  },
  aside: {
    overflow: 'auto',
    color: 'white',
    height: '100%',
    width: '250px',
    padding: '15px 0',
    background: function background(_ref) {
      var dark = _ref.dark;
      return dark ? _styles.colors.jet : _styles.colors.charcoal;
    }
  }
};
var _default = styles;
exports["default"] = _default;